import { makeStyles } from '@fluentui/react-components';
import { themedTabListRules } from './tabTheme';

const useStyles = makeStyles({ tabList: themedTabListRules });

export const useThemedTabs = (): string => useStyles().tabList;
